import React from "react";
import { withPrefix } from "gatsby";

import DefaultImage from "../../../assets/images/not-found/icono_redondo_autor.png";

import "./cardAuthor.scss";

interface AuthorInterface {
  name?: string;
  author: {
    autor: string;
    image: {
      file: {
        url: string;
      };
    };
    tituloBanner: string;
    imagenPrincipal?: 
      {
        file: {
          url: string;
        };
        title: string;
      }
    ;
  };
  search?: Function;
  gtmClass?: string;
}

const CardAuthor = (props: AuthorInterface) => {
  const { author, name } = props;

  return (
    <a
      className="m-author"
      href={withPrefix(`/resultados-busqueda/?search=${
          (author.autor && author.autor) || (author.tituloBanner && author.tituloBanner)
        }&contentType=Todos`)
      }
    >
      <div className={`m-author-content ${props.gtmClass}`}>
        <div className="m-author-content-img">
          <img
            className={`m-author-content ${props.gtmClass}`}
            src={
              (author.imagenPrincipal && author.imagenPrincipal[0].file.url) ||
              DefaultImage
            }
            alt={
              (author.imagenPrincipal && author.imagenPrincipal[0].title) ||
              `Autor comfama`
            }
          />
        </div>
        <h3 className={`m-author-content-name ${props.gtmClass}`}>
          {author.autor || author.tituloBanner || name}
        </h3>
      </div>
    </a>
  );
};

export default CardAuthor;
